import styled from 'styled-components';
import { LinkText } from '@origin-digital/style-guide';

export const ClickableLink = styled(LinkText)`
  cursor: pointer;
`;

export const ClickableUnderLineLink = styled(ClickableLink)`
  text-decoration: underline;
`;
